import React from 'react'
import PropTypes from 'prop-types'

/**
 * Bronson ContextNotification component.
 * @see https://bronson.vwfs.tools/default/components/detail/bronson-context-notification.html
 *
 * @param {Notification|Notification[]} [children] - A collection of {@link Notification} components.
 * @param {string} [testId] - The `[data-testid]` attribute on the component element.
 * @param {object} [otherProps] - Other props passed to the component element.
 * @returns {JSX.Element} - The ContextNotification component.
 * @constructor
 */
export function ContextNotification({ children, testId, ...otherProps }) {
  return (
    <div className="js-context-notification js-is-fx js-is-ready" data-testid={testId} {...otherProps}>
      {React.Children.map(children, (child) => React.cloneElement(child, { context: true }))}
    </div>
  )
}

ContextNotification.propTypes = {
  children: PropTypes.node, // Bronson template: '@bronson-notification'. Use {@link Notification} component.
  testId: PropTypes.string, // Added for `[data-testid]` attribute.
}
